import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { baseUrl } from '../baseUrl.tsx';
// import type { RootState } from '../store.ts';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}`,
    prepareHeaders: (headers, { getState, endpoint }) => {
      // const { token } = (getState() as RootState).app.auth;
      // if (token) {
      //   headers.set('authorization', `Bearer ${token}`);
      // }
      // Don't set Content-Type for FormData endpoints (browser will set it with boundary)
      if (endpoint !== 'uploadContactImages') {
        headers.set('Content-Type', 'application/json');
      }
      return headers;
    },
  }),
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({
        url: `admin/login`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Auth'],
    }),

    contact: builder.mutation({
      query: (body) => ({
        url: `contact`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Auth'],
    }),

    uploadContactImages: builder.mutation({
      query: ({ contactId, formData }) => ({
        url: `contact/${contactId}/images`,
        method: 'POST',
        body: formData,
        // Don't set Content-Type header - browser will set it with boundary for FormData
      }),
      invalidatesTags: ['Auth'],
    }),
  }),
});

export const { useLoginMutation, useContactMutation, useUploadContactImagesMutation } = authApi;
